export default {
  taskSelected: "tw-bg-neutral-gray-5",
};
